import React from "react";
import * as THREE from "three";

// Brooklyn (east) + Jersey City (west) shorelines to anchor bridges & harbor horizon.
export default function Shorelines() {
  const blocks = (baseX, dir, count, seed) => {
    const out = [];
    let s = seed;
    const rnd = () => ((s = (s * 1103515245 + 12345) % 2147483648) / 2147483648);
    for (let i = 0; i < count; i++) {
      const x = baseX + dir * (60 + rnd() * 520);
      const z = -900 + rnd() * 1800;
      const h = 30 + rnd() * 90;
      const w = 26 + rnd() * 40;
      out.push([x, z, w, h]);
    }
    return out;
  };
  const brooklyn = blocks(1180, 1, 34, 777);
  const jersey = blocks(-1050, -1, 30, 991);

  return (
    <group>
      {/* Brooklyn landmass */}
      <mesh rotation={[-Math.PI / 2, 0, 0]} position={[1700, 0.02, 0]} receiveShadow>
        <planeGeometry args={[1200, 2600]} />
        <meshStandardMaterial color="#6d6f68" roughness={0.95} />
      </mesh>
      {/* Jersey City landmass */}
      <mesh rotation={[-Math.PI / 2, 0, 0]} position={[-1650, 0.02, 0]} receiveShadow>
        <planeGeometry args={[1300, 2600]} />
        <meshStandardMaterial color="#6d6f68" roughness={0.95} />
      </mesh>
      {[...brooklyn, ...jersey].map((b, i) => (
        <mesh key={i} position={[b[0], b[3] / 2, b[1]]} castShadow receiveShadow>
          <boxGeometry args={[b[2], b[3], b[2]]} />
          <meshStandardMaterial color={i % 3 === 0 ? "#8f9aa6" : "#b0a999"} roughness={0.7} metalness={0.2} />
        </mesh>
      ))}
    </group>
  );
}
